export default __webpack_public_path__ + "static/media/125.c1460683.gif";